import { useMemo } from 'react';
import { useVisibleRegions } from 'features/mapping/hooks/useVisibleRegions';
import { WildfireListItem } from 'features/wildfires/wildfire.types';
import { FloodingListItem } from 'features/flooding/flooding.types';
import { useReleaseFlag } from 'hooks/useReleaseFlags';

/**
 * Whether a region/county currently in the map viewport is flagged (on a
 * wildfire or flooding event) as having unstructured evacuation zones.
 */
export const useHasVisibleUnstructuredEvacZones = (
  geoEvents: (WildfireListItem | FloodingListItem)[],
): boolean => {
  const enabled = useReleaseFlag('unstructured_evacuations');
  const visibleRegions = useVisibleRegions(enabled);

  const unstructuredEvacuationRegionIds = useMemo(
    () =>
      new Set(
        geoEvents.flatMap(
          (geoEvent) => geoEvent.data.unstructuredEvacuationRegionIds,
        ),
      ),
    [geoEvents],
  );

  const hasVisibleUnstructuredEvacZones = useMemo(
    () =>
      visibleRegions.some((region) =>
        unstructuredEvacuationRegionIds.has(region.region_id),
      ),
    [visibleRegions, unstructuredEvacuationRegionIds],
  );

  return hasVisibleUnstructuredEvacZones;
};
